import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=2bceda50&"
import script from "./FormLabel.vue?vue&type=script&lang=ts&"
export * from "./FormLabel.vue?vue&type=script&lang=ts&"
import style0 from "./FormLabel.vue?vue&type=style&index=0&id=2bceda50&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bceda50')) {
      api.createRecord('2bceda50', component.options)
    } else {
      api.reload('2bceda50', component.options)
    }
    module.hot.accept("./FormLabel.vue?vue&type=template&id=2bceda50&", function () {
      api.rerender('2bceda50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/form/FormLabel.vue"
export default component.exports